export enum LogLevel {
  Dev = 'dev',
  Debug = 'debug',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
  EmailData = 'email-data',
}

type Logger = { (logLevel: LogLevel, ...messages: any[]): void };

export type LeveledLogger = {
  dev: (message: string) => void;
  debug: (message: string) => void;
  info: (message: string) => void;
  warn: (message: string) => void;
  error: (message: string) => void;
  emailData: (message: string) => void;
};

// oxlint-disable-next-line no-console
let loggerSingleton: Logger = console.log;

export function init(logger: Logger): void {
  loggerSingleton = logger;
}

/**
 * @description Should be used for dev messages only.
 */
export function dev(...messages: any[]): void {
  loggerSingleton(LogLevel.Dev, ...messages);
}

/**
 * @description Should be used for debugging only.
 */
export function debug(...messages: any[]): void {
  loggerSingleton(LogLevel.Debug, ...messages);
}

/**
 * @description Should be used for breadcrumbs or other critical steps that the app is doing.
 */
export function info(...messages: any[]): void {
  loggerSingleton(LogLevel.Info, ...messages);
}

/**
 * @description Should be used for non-fatal errors that the app is going to handle.
 */
export function warn(...messages: any[]): void {
  loggerSingleton(LogLevel.Warn, ...messages);
}

/**
 * @description Should be used for fatal errors that the app isn't going to handle.
 */
export function error(...messages: any[]): void {
  loggerSingleton(LogLevel.Error, ...messages);
}

/**
 * @description Should be used for fatal errors that the app isn't going to handle.
 */
export function emailData(...messages: any[]): void {
  loggerSingleton(LogLevel.EmailData, ...messages);
}

export function createDevLeveledLogger(): LeveledLogger {
  return {
    dev: (message: string) => {
      // oxlint-disable-next-line no-console
      console.log(message);
    },
    debug: (message: string) => {
      // oxlint-disable-next-line no-console
      console.log(message);
    },
    info: (message: string) => {
      // oxlint-disable-next-line no-console
      console.log(message);
    },
    warn: (message: string) => {
      // oxlint-disable-next-line no-console
      console.log(message);
    },
    error: (message: string) => {
      // oxlint-disable-next-line no-console
      console.error(message);
    },
    emailData: (message: string) => {
      // oxlint-disable-next-line no-console
      console.error(message);
    },
  };
}

export function createTestLeveledLogger(): LeveledLogger {
  return {
    dev: (_message: string) => {},
    debug: (_message: string) => {},
    info: (_message: string) => {},
    warn: (_message: string) => {},
    // Keep fatal errors: a test server that exits with code 33 must say why.
    // stdout, because CI redirects only stdout into the uploaded server log.
    error: (message: string) => {
      // oxlint-disable-next-line no-console
      console.log(message);
    },
    // Log emails in test since we need them to read invite links etc
    emailData: (message: string) => {
      // oxlint-disable-next-line no-console
      console.log(message);
    },
  };
}
